import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Ranking from "../pages/ranking/page";
import ExposeDetail from "../pages/expose/page";
import Debunk from "../pages/debunk/page";
import About from "../pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/ranking",
    element: <Ranking />,
  },
  {
    path: "/expose/:id",
    element: <ExposeDetail />,
  },
  {
    path: "/debunk",
    element: <Debunk />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;